import axios from "../utils/axios";
import {
  SubCategoryQuery,
  CategoryQuery,
  TopCategoryQuery,
} from "../models/utils";

export function fetchPropertyTopCategories(a11yStandard: string, token: any) {
    return new Promise<TopCategoryQuery>((resolve, reject) => {
      axios
        .get(
          `${process.env.REACT_APP_API_DOMAIN}/property-top-categories/?a11y_standards=${a11yStandard}`,
          {
            headers: { Authorization: "Token " + token },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            resolve(response.data);
          }
          reject(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }


export function fetchPropertyCategories(a11yStandard: string, token: any) {
  return new Promise<CategoryQuery>((resolve, reject) => {
    axios
      .get(
        `${process.env.REACT_APP_API_DOMAIN}/property-categories/?a11y_standards=${a11yStandard}`,
        {
          headers: { Authorization: "Token " + token },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchPropertySubCategories(
  a11yStandard: string,
  category: string,
  token: any
) {
  return new Promise<SubCategoryQuery>((resolve, reject) => {
    axios
      .get(
        `${process.env.REACT_APP_API_DOMAIN}/property-sub-categories/?a11y_standards=${a11yStandard}&category=${category}`,
        {
          headers: { Authorization: "Token " + token },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

